import { StyledSlider } from '@/pages/AdvancedEditor/components/panels/common/StyledSlider';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { ElementType } from 'polotno/model/group-model';
import { ControlNumberInput } from '../../common/ControlNumberInput';

const Container = styled.div`
    display: flex;
    gap: 16px;
    justify-content: center;
    align-items: center;
    width: 220px;
`;

export const CornerRadiusControl = observer(() => {
    const { store } = useAdvancedEditorContext();
    const elements = store.selectedShapes;
    const element = elements[0] as ElementType & { cornerRadius: number };

    if (!element) return null;

    const handleChange = (value: number) => {
        elements.forEach(element => element.set({ cornerRadius: value }));
    };

    return (
        <Container>
            <StyledSlider value={element.cornerRadius} onChange={(_e, value) => handleChange(value as number)} step={1} min={0} max={200} />
            <ControlNumberInput value={element.cornerRadius} onChange={handleChange} min={0} max={200} suffix="px" />
        </Container>
    );
});
